import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { API } from '../../shared/api.constants';
import { map } from 'rxjs/operators';
import * as Moment from 'moment';
import { Observable } from 'rxjs/Rx';
import { ResponseWrapper } from '../../shared';
import { SaveAuditService } from 'src/app/shared/utils/save-audit.service';
@Injectable()
export class Invoices {

	dataa: any;
	private resourceDownloadPdfUrl = API.host + 'InvoicePortal/Invoice-download-pdf';
	private resourceDownloadXmlUrl = API.host + 'InvoicePortal/Invoice-download-xml';
	private resourcePreviewUrl = API.host + 'InvoicePortal/InvoicePortal-preview';
	private resourceReleaseInfoUrl = API.host + 'InvoicePortal/InvoicePortal-release-info';
	private resourceUrl = API.host + 'InvoicePortal/InvoicePortal-templates';
	// private resourceUrlGetToken = API.host + 'InvoicePortal/InvoicePortal-GetTokenByInvoiceCode';
	private resourceUrlSearchInvoiceByInvoiceNo = API.host + 'InvoicePortal/SearchInvoiceByInvoiceNo';
	private resourceUrlSearchInvoiceByVeriCode = API.host + 'InvoicePortal/SearchInvoiceByVeriCode';
	private resourceUrlSearchAnnounByVeriCode = API.host + 'InvoicePortal/Search-Announ-By-VeriCode';
	private resourceUrlSearchAnnounByInvoiceNo = API.host + 'InvoicePortal/Search-Announ-By-InvoiceNo';
	private resourceUrlGetCompanyID = API.host + 'InvoicePortal/InvoicePortal-get-companyID';
	private resourceDownloadAnnounPdfUrl = API.host + 'InvoicePortal/Announcement-download-pdf';
	
    private getListStatiscals = API.host + 'InvoicePortal/getListStatiscal';
    private getListGifts = API.host + 'InvoicePortal/getListGift';
    private resourceDownloadStatiscal = API.host + 'InvoicePortal/downloadStatistical';
    private resourceDownloadGift = API.host + 'InvoicePortal/downloadInvoiceGift';
	
	constructor(private http: HttpClient,
				private saveAuditService: SaveAuditService,) { }

	SearchInvoice(item: any) {
		return this.http.get(`${this.resourceUrlSearchInvoiceByVeriCode}/${item}`)
			.pipe(map(
				(res: HttpResponse<any>) => {
					return res
				}))
			;
	}
	
	SearchInvoiceByVeriCodeLogin(req: any) {
		let params = new HttpParams({
			fromObject: req.searchParams
		  });
		return this.http.get(`${this.resourceUrlSearchInvoiceByVeriCode}`, { params: params })
		.pipe(map(
			(res: HttpResponse<any>) => {
				return res
			})
		);
	}
		

	SearchAnnouncement(code: any) {
		return this.http.get(`${this.resourceUrlSearchAnnounByVeriCode}/${code}`)
			.pipe(map(
				(res: HttpResponse<any>) => {
					return res
				}))
			;
	}

	SearchAnnouncementByVeriCodeLogin(req: any) {
		let params = new HttpParams({
			fromObject: req.searchParams
		  });
		return this.http.get(`${this.resourceUrlSearchAnnounByVeriCode}`, { params: params })
			.pipe(map(
				(res: HttpResponse<any>) => {
					return res
				})
		);
	}
	
	SearchInvoiceByInvoiceNo(req?: any) {
		let params = new HttpParams({
			fromObject: req.searchParams
		  });

		return this.http.get(`${this.resourceUrlSearchInvoiceByInvoiceNo}`, { params: params }).pipe(map(
			(res: HttpResponse<any>) => {
				return res
			})
		);
	}

	SearchAnnouncementByInvoiceNo(req?: any) {
		let params = new HttpParams({
			fromObject: req.searchParams
		  });
		return this.http.get(`${this.resourceUrlSearchAnnounByInvoiceNo}`, { params: params }).pipe(map(
			(res: HttpResponse<any>) => {
				return res
			})
		);
	}

	downloadPDF(id: number, callback) {
		try {
			const xhr = new XMLHttpRequest();
			xhr.open('GET', `${this.resourceDownloadPdfUrl}/${id}`);
			xhr.responseType = 'arraybuffer';

			xhr.onload = function () {
				if (xhr.status === 200) {
					const blob = new Blob([xhr.response], {
						type: 'application/pdf'
					});

					if (window.navigator && window.navigator.msSaveOrOpenBlob) {
						let strTime = Moment(new Date()).format('YYYYMMDDHHmmss');
						let fileName = "hoa-don_" + strTime + ".pdf";
						window.navigator.msSaveOrOpenBlob(blob, fileName);
						return;
					}
					else {
						const url = window.URL.createObjectURL(blob);
						callback(url);
					}
				}
			};
			xhr.send();
			this.saveAudit(true, true);
		} catch (error) {
			console.error('error', error);
		}
	}

	downloadXML(id: number, callback) {
		try {
			const xhr = new XMLHttpRequest();
			xhr.open('GET', `${this.resourceDownloadXmlUrl}/${id}`);
			xhr.responseType = 'arraybuffer';

			xhr.onload = function () {
				if (xhr.status === 200) {
					const blob = new Blob([xhr.response], {
						type: 'application/xml'
					});

					if (window.navigator && window.navigator.msSaveOrOpenBlob) {
						let strTime = Moment(new Date()).format('YYYYMMDDHHmmss');
						let fileName = "hoa-don_" + strTime + ".xml";
						window.navigator.msSaveOrOpenBlob(blob, fileName);
						return;
					}
					else {
						const url = window.URL.createObjectURL(blob);
						callback(url);
					}
				}
			};
			xhr.send();
			this.saveAudit(true, false);
		} catch (error) {
			console.error('error', error);
		}
	}

	downloadAnnounPDF(id: number, companyId: number, callback) {
		try {
			const xhr = new XMLHttpRequest();
			xhr.open('GET', `${this.resourceDownloadAnnounPdfUrl}/${id}/${companyId}`);
			xhr.responseType = 'arraybuffer';

			xhr.onload = function () {
				if (xhr.status === 200) {
					const blob = new Blob([xhr.response], {
						type: 'application/pdf'
					});

					if (window.navigator && window.navigator.msSaveOrOpenBlob) {
						let strTime = Moment(new Date()).format('YYYYMMDDHHmmss');
						let fileName = "bien-ban_" + strTime + ".pdf";
						window.navigator.msSaveOrOpenBlob(blob, fileName);
						return;
					}
					else {
						const url = window.URL.createObjectURL(blob);
						callback(url);
					}
				}
			};
			xhr.send();
			this.saveAudit(false, true);
		} catch (error) {
			console.error('error', error);
		}
	}
	saveAudit(isInvoice: boolean, isPdf: boolean){
		var infoLogin = JSON.parse(sessionStorage.getItem("login"));
		var logDetail = isInvoice ? 'Download invoice file' : 'Download announcement file';
		if(isInvoice){
			logDetail = isPdf ? logDetail + " pdf" : logDetail + " xml";
		}
		if (infoLogin) {
			this.saveAuditService.saveAudit({
				functionCode : 'Portal',
				logSummary: isInvoice ? "Portal [Download invoice]" : "Portal [Download announcement]",
				logDetail: logDetail,
				userId: infoLogin.userId,
			}, true);
			//this.http.get(`${this.resourceUrlSaveAudit}/${isInvoice}/${logType}/${infoLogin.userId}`).subscribe();
		}
        
	}


	// saveAudit(req?: any): Observable<ResponseWrapper> {

	// 	this.http.get(`${this.resourceUrlSaveAudit}`)

    //     return this.http
    //         .get(`${this.resourceUrlSaveAudit}`, req)
    //         .map((res: any) => {
    //             if (!res || !res.json) {
    //                 throw 'Invalid Code';
    //             }
    //             return res.json().data;
    //         });
    // }
	findPreview(id: number) {
		return this.http.get(`${this.resourcePreviewUrl}/${id}`).pipe(map(
			(res: HttpResponse<any>) => {
				return res
			}))
			;
	}

	getReleaseInfo(id: number, companyID: number) {
		return this.http.get(`${this.resourceReleaseInfoUrl}/${id}/${companyID}`).pipe(map(
			(res: HttpResponse<any>) => {
				return res
			}))
			;
	}

	query(companyID: number) {
		return this.http.get(`${this.resourceUrl}/${companyID}`).pipe(map((res: Response) => {
			return res
		}))
			;
	}

	getCompanyIdByCode(Type: string, VerifiCode: string) {
		return this.http.get(`${this.resourceUrlGetCompanyID}/${Type}/${VerifiCode}`).pipe(map((res: any) => {
			return res.data;
		}))
			;
	}
	
    getListStatiscal(id: number): Observable<any> {
        return this.http.get(`${this.getListStatiscals}/${id}`).map((res: any) => {
            if (!res || !res.data) {
                throw 'Invalid Code';
            }

            return res.data;
        });
	}
	
    getListGift(id: number): Observable<any> {
        return this.http.get(`${this.getListGifts}/${id}`).map((res: any) => {
            if (!res || !res.data) {
                throw 'Invalid Code';
            }

            return res.data;
        });
	}
	
    downloadStatiscal(id: number, callback) {
        try {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', `${this.resourceDownloadStatiscal}/${id}`);
            xhr.responseType = 'arraybuffer';
            xhr.onload = function() {
                if (xhr.status === 200) {
                    const blob = new Blob([xhr.response], {
                        type: 'application/pdf'
                    });
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob,"statistical.pdf");
                        return;
                    } 
                    else{
                        const url = window.URL.createObjectURL(blob);
                        callback(url);
                    }
                }
            };
			xhr.send();
			this.saveAudit(true, true);
        } catch (error) {
            console.error('error', error);
        }
	}
	
    downloadGift(id: number, callback) {
        try {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', `${this.resourceDownloadGift}/${id}`);
            xhr.responseType = 'arraybuffer';
            xhr.onload = function() {
                if (xhr.status === 200) {
                    const blob = new Blob([xhr.response], {
                        type: 'application/pdf'
                    });
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob,"invoiceGift.pdf");
                        return;
                    } 
                    else{
                        const url = window.URL.createObjectURL(blob);
                        callback(url);
                    }
                }
            };
			xhr.send();
			this.saveAudit(true, true);
        } catch (error) {
            console.error('error', error);
        }
    }
	
}
